import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IFair } from "../types/seed";

const API = process.env.REACT_APP_API;

const useCurrentFairWindow = () => {
  const fetch = useFetch();

  return useQuery({
    queryKey: ["fair"],
    queryFn: () => {
      return fetch(
        `${API}/api/semeadora/fairs/current/window/`,
      ) as Promise<IFair>;
    },
    onError: (error) => {
      console.log("onError", error);
    },
  });
};

export default useCurrentFairWindow;
